import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {IDashboardState} from '../reducer/dashboard-reducer';


export const getDashboardState = createFeatureSelector<IDashboardState>(
  'dashboard-store'
);

export const getDashBoardCurrentState = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state;
  }
);

export const getTabId = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.tabId;
  }
);

export const getQueryParameters = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.queryParameters;
  }
);

export const getFilterSummaryDisplayItems = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.filterSummaryDisplayItems;
  }
);
export const getDashboardReportDetails = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.dashboardReportDetails;
  }
);
export const getAnalyticReportDetails = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.analyticReportDetails;
  }
);
export const getDashboardReportError = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.dashboardReportError;
  }
);
export const getAnalyticReportError = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.analyticReportError;
  }
);
export const getDac6AnalyticReportDetails = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.dac6AnalyticReportDetails;
  }
);
export const getDac6AnalyticReportError = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.dac6AnalyticReportError;
  }
);
export const resetAnalyticsSuccess = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.analyticsRefreshData;
  }
);
export const resetAnalyticsError = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.analyticReportError;
  }
);
export const resetAnalyticsStatus = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.isAnalyticsResetOnGoing;
  }
);
export const resetDac6AnalyticsSuccess = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.dac6AnalyticsRefreshData;
  }
);
export const resetDac6AnalyticsError = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.dac6AnalyticReportError;
  }
);
export const resetDac6AnalyticsStatus = createSelector(
  getDashboardState,
  (state: IDashboardState) => {
    return state.isDac6AnalyticsResetOnGoing;
  }
);
